import "../scss/icons.scss";

import { css } from "styled-components";
import fontIconSvg from "./fonticon.svg";
import fontIconWoff from "./fonticon.woff";

export const fontIcon = css`
    @font-face {
        font-family: "fonticon";
        src:
            url(${fontIconWoff}) format("woff"),
            url(${fontIconSvg}) format("svg");
        font-weight: normal;
        font-style: normal;
    }

    [class^="icon-"],
    [class*=" icon-"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: "fonticon" !important;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        vertical-align: middle;
        display: inline-block;

        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
`;
